import { Controller } from "@hotwired/stimulus"
import { apiGet, t } from "../api_helper"
import { isOfflineError } from "../lib/offline_ui"
import "../lib/paywall"

export default class extends Controller {
  static targets = ["premiumGate", "grid"]

  connect() {
    this.checkPremium()
  }

  async checkPremium() {
    try {
      const data = await apiGet("/api/subscription")
      if (!data.premium) {
        this.lockForFree()
      }
    } catch (e) {
      this.lockForFree()
    }
  }

  lockForFree() {
    if (this.hasPremiumGateTarget) {
      this.premiumGateTarget.classList.remove("hidden")
    }
    if (this.hasGridTarget) {
      this.gridTarget.style.opacity = "0.4"
      this.gridTarget.style.pointerEvents = "none"
      this.gridTarget.style.filter = "blur(2px)"
    }
  }
}
